<template>
  <div class="ofs-transactions">
    <UITabs v-model="tab" :tabs="TABS" :disabled="!initialized" :squeezeWidth="400" />
    <div class="ofs__block">
      <template v-if="tab === 'New transactions'">
        <UIPreloader v-if="!initialized" message="Loading tree..." class="ofs__preloader" />
        <OFSTransactionsNew
          v-else
          ref="transactionsRef"
          v-model:dates="transactionDatesMap"
          :transactions
          :transaction-settings
          @delete="handleDeleteTransaction"
        />
      </template>
      <OFSTransactionsHistoric v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'

import { TransactionSettings } from '@types'
import { OrganizeFamilyStructureTransaction } from './utils/types'

import { UIPreloader, UITabs } from '@ui/core'
import OFSTransactionsNew from './OrganizeFamilyStructureTransactionsNew.vue'
import OFSTransactionsHistoric from './OrganizeFamilyStructureTransactionsHistoric.vue'
import { CalendarDateRangeIcon, PlusIcon } from '@heroicons/vue/24/outline'

type Props = {
  initialized: boolean
  transactions: OrganizeFamilyStructureTransaction[]
  transactionSettings?: TransactionSettings
}

type Emits = {
  delete: [index: number]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const transactionDatesMap = defineModel<Map<string, string>>('dates', { required: true })

defineExpose({
  scrollToBottom: () => {
    transactionsRef.value?.scrollToBottom()
  },
})

const TABS = [
  { name: 'New transactions', icon: PlusIcon },
  { name: 'Historic transactions', icon: CalendarDateRangeIcon },
]

const transactionsRef = useTemplateRef('transactionsRef')

const tab = ref<string>(TABS[0].name)

const handleDeleteTransaction = (index: number) => {
  emit('delete', index)
}
</script>

<style>
.ofs-transactions {
  @apply h-1/2 min-h-[200px] lg:min-h-[300px];
  @apply flex-auto flex flex-col gap-2;
  @apply overflow-hidden;

  .ofs__block {
    @apply flex-auto;
  }
}
</style>
